export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f8ee7af62711d57c2145f4f00374a47321ba42c62&name=fetchTypeahead!'